/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
  useState,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */
import ThanksEmbedded from '../../thanks/ThanksEmbedded';

/**
 * 埋込み型 Thanks component を作成します
 * - {@link ThanksEmbedded}
 * @param {*} state {@link survey}.Context.state
 * @param {*} submit Redux.store.submit - submit 状態を保持します
 * @param {boolean} desktop - resize desktop flag
 * @return {*} React.node
 * @constructor
 */
const WidgetEmbeddedThanks = ({ state, submit, desktop }) => (
  <ThanksEmbedded
    title={state.config.thanks.txt0}
    // state.step 使用しない
    // message={submit.payload.step === 99 ? state.config.thanks.txt1 : ''}
    message={state.config.thanks.txt1}
    // test code
    // message={state.config.thanks.txt1}
    submit={submit}
    desktop={desktop}
    state={state}
  />
);

export default WidgetEmbeddedThanks;



// WEBPACK FOOTER //
// ./src/embedded-type/survey/page/widget/sequence/WidgetEmbeddedThanks.js